export default "__VITE_ASSET__BsGpeh5q__"